import { Button, Stack } from '@mui/material';
import { useApp, useTriggerAction } from '@k3/core';
import { partition } from 'lodash';
import { useIsKioskMode } from '../../hooks/useIsKioskMode';
import { OverviewTischTable } from '../configurator/tisch/Overview';
import {
  EINZELTEIL_KONFIGURATOR_APP_CODE,
  isModulmoebelKonfigurator,
  TISCH_KONFIGURATOR_APP_CODE,
} from '../../constants';
import { OverviewModulmoebelTable } from '../configurator/modulmoebel/Overview';
import { OverviewEinzelteilTable } from '../configurator/einzelteil/Overview';

const usps = [
  'Schreinerqualität - Made in Germany',
  'Individuell für Sie gefertigt',
  '5 Jahre Garantie',
];

export const Overview = () => {
  const app = useApp();
  return (
    <Stack sx={{ p: 3 }}>
      {app.code === TISCH_KONFIGURATOR_APP_CODE && (
        <OverviewTischTable usps={usps} />
      )}
      {app.code === EINZELTEIL_KONFIGURATOR_APP_CODE && (
        <OverviewEinzelteilTable usps={usps} />
      )}
      {isModulmoebelKonfigurator(app.code) && (
        <OverviewModulmoebelTable usps={usps} />
      )}
      <Stack sx={{ m: 2 }} />
      <FinishButtons />
    </Stack>
  );
};

const FinishButtons = () => {
  const order = useTriggerAction();
  const kiosk = useIsKioskMode();
  const actions = useApp().settings.actions.slice().reverse();
  const app = useApp();
  const [[mainAction], sideActions] = partition(actions, (a) =>
    kiosk ? a.pdf : a.id === app.settings.defaultAction
  );
  const pdfAction = sideActions.find((a) => a.pdf) ?? sideActions[0];
  const saveAction = sideActions.find((a) => !a.pdf) ?? sideActions[1];
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr',
        gridRow: 'auto auto',
        gridColumnGap: '20px',
        gridRowGap: '20px',
      }}
    >
      {mainAction && (
        <Button
          variant="contained"
          onClick={() => order(mainAction)}
          sx={{ gridColumn: '1 / -1' }}
        >
          {mainAction.label.de}
        </Button>
      )}
      {!kiosk && (
        <>
          {pdfAction && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => order(pdfAction)}
              fullWidth
              sx={{ gridColumn: '1 / 1' }}
            >
              {pdfAction.label.de}
            </Button>
          )}

          {saveAction && (
            <Button
              variant="contained"
              color="secondary"
              onClick={() => order(saveAction)}
              fullWidth
              sx={{ gridColumn: '2 / 2' }}
            >
              {saveAction.label.de}
            </Button>
          )}
        </>
      )}
    </div>
  );
};
